export function getFixedLayoutHeaderHeight() {
    return 8;
}
export function toPercent(percent) {
    return `${percent}%`;
}
//# sourceMappingURL=Contact3DFixedLayoutUtils.js.map